import accountManagersDataService from "../../../../services/accountManagersDataService";

export default {
  data() {
    return {
      accountManagers: [],
    }
  },
  methods: {
    getActiveAccountManagers() {
      return accountManagersDataService.getActiveAccountManagers()
        .then(accountManagers => {
          accountManagers.forEach(manager => {
            this.accountManagers.push({
              name: manager.name,
              id: manager.id,
              selectable: true,
            })
          })
        })

    },
  }
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/AccountManager/accountManagerFormMixin.js